import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';

type RemoveUserFromLocationGroupDialogProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => Promise<void>;
  isRemoveUserFromLocationGroupInProgress?: boolean;
};

export const RemoveUserFromLocationGroupDialog = ({
  open,
  setOpen,
  onConfirm,
  isRemoveUserFromLocationGroupInProgress,
}: RemoveUserFromLocationGroupDialogProps) => (
  <ConfirmDialog
    dialogTitle='Remove User From Location Group'
    confirmButtonText='Remove'
    open={open}
    onClose={() => setOpen(false)}
    confirmButtonProps={{
      onClick: onConfirm,
      color: 'error',
      disabled: isRemoveUserFromLocationGroupInProgress,
    }}
  >
    {isRemoveUserFromLocationGroupInProgress && <LinearProgress />}

    <Typography>
      Are you sure you would like to remove this User from this Location Group? This will not delete
      the user, only remove their access to this Location Group.
    </Typography>
  </ConfirmDialog>
);
